import type { ApiFn } from '@/api/factory/base/api';
import { useMakeQuery } from '@/api/use-make-query';
import { QUERY_KEYS } from '@/features/info-top-banner/api/query-keys';
import type { InfoTopBanner } from '@/features/info-top-banner/types/info-top-banner';

export const getInfoTopBannerConfig = (enabled?: boolean) => {
  const apiFn: ApiFn<InfoTopBanner> = (api) => api.get('/marketing/topBanner');

  return {
    apiFn,
    queryKey: [QUERY_KEYS.INFO_TOP_BANNER],
    enabled,
  };
};

export const useInfoTopBannerQuery = (enabled?: boolean) => {
  return useMakeQuery(getInfoTopBannerConfig(enabled));
};
